export const PDF_IMAGE_OFFSET = 30;
export const PDF_IMAGE_PADDING = PDF_IMAGE_OFFSET * 2;

export const FILE_EXTENSION = {
  PNG: 'png',
  PDF: 'pdf',
};

export const COLUMN_MARGIN_RATIO = 0.1; // 10% of total column width
export const COLUMN_WIDTH = {
  SMALL: 10,
  MEDIUM: 30,
  LARGE: 60,
};

export const CHART_TYPE = {
  BAR: 'Bar',
  LINE: 'Line',
  COLUMN: 'Column',
};

export const ORIENTATION_TYPE = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export const DISPLAY_VALUES = {
  DISPLAY: {
    label: 'Display',
    value: 1,
  },
  DONT_DISPLAY: {
    label: `Don't display`,
    value: 0,
  },
};

export const LABEL_FONT_SIZE = 10;
export const LINE_CHART_DATA_OFFSET_FACTOR = 0.1;
export const LABEL_FONT_FAMILY = 'AvenirLTPro-Medium';
export const LABEL_FONT_FAMILY_COMMUNITY = 'AvenirLTPro-Heavy';
export const LABEL_FONT_COLOR = '#1d252d';
export const GRID_STROKE_COLOR = '#eee';
export const GRID_STROKE_SWOT_COLOR = '#89919d';
export const SWOT_PERFORMANCE_BETTER_REGION_COLOR = '#0ab776';
export const SWOT_PERFORMANCE_WORSE_REGION_COLOR = '#fa7550';

export const MIN_BAR_WIDTH = 15;
export const MAX_BAR_WIDTH = 15;

export const INTERVAL_PADDING = 16;
export const DISTANCE_BETWEEN_GROUP_COLUMNS = 5;

export const ANTD_PLOT_CHART_COLUMN_WIDTH = 30;
export const COLUMN_CHART_OFFSET = 70; // padding of the chart widget + approximate y axis width

export const XAXIS_LABEL_LENGTH = 25;
export const LEGEND_MAX_ROWS = 10;
export const LEGEND_FONT_SIZE = 18;
export const LEGEND_FONT_FAMILY = 'AvenirLTPro-Medium';
export const LEGEND_FONT_COLOR = '#222222';
export const LEGEND_FONT_WEIGHT = 500;
export const COLOR_DEFAULT = 'l(0) 0:#999 1:#000';
export const COLOR_OPACITY = 'FF'; // 70% Opacity
export const COLOR_PALETTES = {
  GRADIENTS: [
    'l(0) 0:#9898ff 1:#5f5fff',
    'l(0) 0:#47e9ea 1:#22cfd1',
    'l(0) 0:#ff94c9 1:#ff5b98',
    'l(0) 0:#17dcae 1:#0ab776',
    'l(0) 0:#fdad88 1:#fa7550',
    'l(0) 0:#b6b6b6 1:#7f7f7f',
    'l(0) 0:#25549a 1:#102a61',
    'l(0) 0:#ffe500 1:#ffc600',
    'l(0) 0:#42afdb 1:#1f77b4',
    'l(0) 0:#dfe047 1:#bcbd22',
    'l(0) 0:#e4d8ec 1:#c5b0d5',
    'l(0) 0:#c08f82 1:#8c564b',
    'l(0) 0:#ed4f51 1:#d62728',
    'l(0) 0:#f3afe3 1:#e377c2',
    'l(0) 0:#ffdfb0 1:#ffbb78',
  ],
  BORDERS: [
    '#5f5fff',
    '#22cfd1',
    '#ff5b98',
    '#0ab776',
    '#fa7550',
    '#7f7f7f',
    '#102a61',
    '#ffc600',
    '#1f77b4',
    '#bcbd22',
    '#c5b0d5',
    '#8c564b',
    '#d62728',
    '#e377c2',
    '#ffbb78',
  ],
  DEFAULT: [
    '#00429d',
    '#2b57a7',
    '#426cb0',
    '#5681b9',
    '#6997c2',
    '#7daeca',
    '#93c4d2',
    '#abdad9',
    '#caefdf',
    '#ffffe0',
  ],
  DIVERGING: [
    '#00429d',
    '#3e67ae',
    '#618fbf',
    '#85b7ce',
    '#b1dfdb',
    '#ffcab9',
    '#fd9291',
    '#e75d6f',
    '#c52a52',
    '#93003a',
  ],
  PASTEL: [
    '#ffadad',
    '#ffd6a5',
    '#fdffb6',
    '#caffbf',
    '#9bf6ff',
    '#a0c4ff',
    '#bdb2ff',
    '#ffc6ff',
    '#ceb8a1',
    '#d598f0',
    '#e3dcba',
    '#d7a4b7',
    '#f78e88',
    '#8297af',
    '#c1cc89',
    '#8fbdf9',
    '#e7f681',
    '#add9b2',
    '#d5a2f6',
    '#eaafe9',
    '#a7a1b4',
    '#bdf3d6',
    '#dbe1bb',
    '#9fb98e',
    '#ae93e2',
    '#84f1f9',
    '#b5c4d1',
    '#d6c1f1',
    '#bcba93',
    '#b4d7c7',
    '#dcd6b6',
    '#b1dddf',
    '#93e2df',
    '#cca280',
    '#e7f8b4',
    '#e7bfd2',
    '#a0e9d4',
    '#c0b9dc',
  ],
  CONTRAST: [
    '#54478c',
    '#2c699a',
    '#048ba8',
    '#0db39e',
    '#16db93',
    '#83e377',
    '#b9e769',
    '#efea5a',
    '#f1c453',
    '#f29e4c',
  ],
  EARTH: ['#797d62', '#9b9b7a', '#baa587', '#d9ae94', '#f1dca7', '#ffcb69', '#e8ac65', '#d08c60', '#b58463', '#997b66'],
};
